export const KPI_CONFIG = [
  { key: "CPIB", title: "CPIB" },
  { key: "CBIB", title: "CBIB" },
  { key: "CPPIB", title: "CPPIB" },
  { key: "CPOIB", title: "CPOIB" },
  { key: "KAPAL", title: "CPIB Kapal", sourceKey: "CBIB_Kapal" },
  { key: "CDOIB", title: "CDOIB" },
  // { key: "MOHON", title: "TOTAL PERMOHONAN", sourceKey: "total", col: 6 },
  { key: "TERBIT", title: "TOTAL TERBIT", sourceKey: "total", col: 12 },
];
